// Qureka-style "Hurray! double your coins" popup.
// onClaim() -> trigger rewarded ad; onClose() -> keep base coins.
export default function RewardModal({ coins, onClaim, onClose }) {
  return (
    <div className="fade-in fixed inset-0 z-[90] bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-6">
      <div className="glass-panel w-full max-w-sm p-10 rounded-[3rem] text-center pop-in shadow-2xl">
        <div className="float-icon text-7xl mb-4">🧰</div>
        <h2 className="text-3xl font-black italic uppercase text-emerald-400 mb-1">
          Hurray!!
        </h2>
        <p className="text-[11px] font-black uppercase tracking-[0.3em] text-slate-400 mb-6">
          Correct Answer
        </p>

        <p className="text-xl font-black text-white mb-1">
          You won <span className="text-emerald-400">{coins} coins</span>
        </p>
        <p className="text-xs text-slate-400 mb-8">
          You have a chance to double your coins by watching an ad.
        </p>

        <button
          onClick={onClaim}
          className="btn-3d relative w-full py-6 bg-emerald-600 hover:bg-emerald-500 rounded-[2rem] text-white font-black uppercase tracking-widest text-base"
        >
          <span className="absolute top-2 right-4 text-[8px] font-bold text-white/70">
            Ad
          </span>
          💎 Claim &amp; Double
        </button>

        <button
          onClick={onClose}
          className="mt-5 text-xs font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-all underline"
        >
          Close
        </button>
      </div>
    </div>
  );
}
